// src/pages/NewPage.tsx
import React, { useState } from 'react';
import logoCorge from '../assets/logos/logo-corgee.png';

export const NewPagePage: React.FC = () =>
{
  const [loading, setLoading] = useState(true);

  setTimeout(() =>
  {
    setLoading(false);
  }, 300);

  if (loading)
  {
    return (
      <div className="min-h-screen bg-[#ededed] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#5dade2] mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#ededed]">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={logoCorge} alt="Corgee Logo" className="w-10 h-10 object-contain" />
            <h1 className="text-2xl font-semibold text-[#5dade2]">Corgee Placeholder</h1>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-xl shadow-md p-8">
          <div className="flex items-center gap-4 mb-6">
            <div>
              <h2 className="text-2xl font-semibold text-gray-800">Corgee</h2>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-6">
            <h3 className="text-lg font-semibold text-gray-700 mb-4">New Page</h3>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center text-xs text-gray-400">
          Corgee © CGBOT {new Date().getFullYear()}
        </div>
      </main>
    </div>
  );
};
